var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    { attrs: { "data-test": _vm.CypressTarget("PromoterCard") } },
    [
      _c(
        "q-card-title",
        { attrs: { "data-test": _vm.CypressTarget("Title") } },
        [_vm._v("\n    " + _vm._s(_vm.$t("cards.promoter.title")) + "\n  ")]
      ),
      _vm.alias
        ? _c(
            "q-card-main",
            [
              _c(
                "q-list",
                { attrs: { "no-border": "" } },
                [
                  _c(
                    "q-item",
                    [
                      _c(
                        "q-item-side",
                        { attrs: { "data-test": _vm.CypressTarget("Name") } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("cards.promoter.name")) +
                              ":\n        "
                          )
                        ]
                      ),
                      _c(
                        "q-item-main",
                        [
                          _c(
                            "q-item-tile",
                            {
                              staticClass: "q-title",
                              attrs: {
                                "data-test": _vm.CypressTarget("Alias"),
                                label: ""
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.alias) +
                                  "\n            "
                              ),
                              _vm.city && _vm.state
                                ? _c("span", { staticClass: "q-caption" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.city) +
                                        " - " +
                                        _vm._s(_vm.state) +
                                        "\n            "
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.description
                    ? _c(
                        "q-item",
                        [
                          _c(
                            "q-item-side",
                            {
                              attrs: {
                                "data-test": _vm.CypressTarget(
                                  "DescriptionTitle"
                                )
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("cards.promoter.description")) +
                                  ":\n        "
                              )
                            ]
                          ),
                          _c(
                            "q-item-main",
                            [
                              _c(
                                "q-item-tile",
                                {
                                  attrs: {
                                    "data-test": _vm.CypressTarget(
                                      "Description"
                                    ),
                                    label: ""
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.description) +
                                      "\n          "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c("q-card-separator"),
      _c(
        "q-card-actions",
        [
          _c(
            "q-field",
            { staticClass: "col-12" },
            [
              _c("q-btn", {
                attrs: {
                  label: _vm.$t("cards.promoter.selectPromoter"),
                  "data-test": _vm.CypressTarget("OpenDialog"),
                  color: _vm.SET_COLOR_BUTTON.primary,
                  "text-color": _vm.SET_COLOR_BUTTON.text.primary,
                  flat: ""
                },
                on: {
                  click: function($event) {
                    _vm.$emit("selectPromoter", true)
                  }
                }
              }),
              _vm._t("default")
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }